import curry from "lodash.curry";

export const addPropertyPrefix = curry((prefix, fn, prop) => fn(`${prefix}.${prop}`));

export const onCheckBoxChange = onPropertyChange => event => onPropertyChange(event.target.checked);

export const onSliderChange = (onPropertyChange, min, max) => (_, value) => {
  if (value) {
    if (value <= min) {
      onPropertyChange(min);
    } else if (value >= max) {
      onPropertyChange(max);
    } else {
      onPropertyChange(value);
    }
  } else {
    onPropertyChange(min);
  }
};

export const onTextBoxChange = onPropertyChange => event => {
  return onPropertyChange(event.target.value);
};

export const onDynamicInputChange = onPropertyChange => value => onPropertyChange(value?.value ?? value);

export const onAutosuggestChange = onPropertyChange => suggestion => {
  onPropertyChange(suggestion.value);
};

export const onAutosuggestObjectChange = onPropertyChange => suggestion => {
  onPropertyChange(suggestion.value, suggestion.name);
};

export const onAutocompleteChange = onPropertyChange => event => {
  onPropertyChange({ id: event.target.value, name: event.currentTarget.innerText });
};
